// import * as React from "react"
// const OptimizeSVG = (props) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     xmlSpace="preserve"
//     // width={100}
//     // height={100}
//     viewBox="-30 -47 180 180"
//     {...props}
//   >
//     <path
//       fillRule="evenodd"
//       d="M25.895 0c-2.999 0-5.879.512-8.557 1.449l6.808 7.368c15.465 16.73-1.987 26.41-17.369 14.926L.845 19.314A25.922 25.922 0 0 0 0 25.896c0 14.303 11.593 25.896 25.895 25.896 4.667 0 9.042-1.236 12.823-3.396l12.704 13.486-29.311 25.126a9.707 9.707 0 0 0-2.47 2.119l-.084.072.014.012a9.617 9.617 0 0 0-2.158 6.082 9.654 9.654 0 0 0 17.99 4.865L61.44 72.516l26.391 28.016a9.606 9.606 0 0 0 8.17 4.551c5.304 0 9.605-4.301 9.605-9.605a9.57 9.57 0 0 0-2.312-6.248l.03-.029-.234-.203a9.672 9.672 0 0 0-1.779-1.523L71.46 61.881l12.702-13.485a25.781 25.781 0 0 0 12.824 3.395c14.302 0 25.896-11.593 25.896-25.896 0-2.274-.295-4.481-.846-6.582l-5.932 4.429c-15.381 11.484-32.833 1.805-17.368-14.926l6.808-7.368A25.896 25.896 0 0 0 96.986 0C82.685 0 71.091 11.593 71.091 25.896a25.775 25.775 0 0 0 4.794 15.014L61.44 53.291 46.996 40.908a25.779 25.779 0 0 0 4.794-15.013C51.79 11.593 40.197 0 25.895 0z"
//       fill={'whitesmoke'}
//       clipRule="evenodd"
//     />
//   </svg>
// )
// export default OptimizeSVG


import * as React from "react"
const OptimizeSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 122.88 94.12",
    }}
    // viewBox="0 0 122.88 94.12"
    viewBox="-30 -55 180 180"
    {...props}
  >
    <path
      d="M6.33 0h91.16c3.46 0 6.33 2.87 6.33 6.34V39.5c-1.96-.71-4.03-1.2-6.16-1.45V11.91H6.08v54.41h61.03c.08 2.07.38 4.07.89 6H6.33C2.87 72.32 0 69.45 0 65.98V6.34C0 2.87 2.87 0 6.33 0zm89.53 45.36c5.87 0 11.19 2.39 15.05 6.23 3.85 3.86 6.23 9.16 6.23 15.05 0 4.29-1.28 8.3-3.46 11.64l9.21 10.04-6.35 5.81-8.88-9.77a21.163 21.163 0 0 1-11.78 3.56c-5.87 0-11.19-2.39-15.04-6.23a21.166 21.166 0 0 1-6.23-15.04c0-5.87 2.39-11.19 6.23-15.05 3.83-3.87 9.14-6.24 15.02-6.24zm11.31 9.96c-2.89-2.89-6.9-4.69-11.31-4.69s-8.42 1.8-11.31 4.69c-2.89 2.89-4.69 6.9-4.69 11.31s1.8 8.42 4.69 11.31c2.89 2.89 6.9 4.69 11.31 4.69s8.42-1.8 11.31-4.69c2.89-2.89 4.69-6.9 4.69-11.31s-1.79-8.41-4.69-11.31zm-48.12-1.84h10.69a26.7 26.7 0 0 0-1.34 3.38h-9.34v-3.38h-.01zm0-8.62h17.14a27.479 27.479 0 0 0-3.18 3.38H59.05v-3.38zm18.76-15.29h4.73c.25 0 .42.17.42.42v9.29c0 .25-.17.42-.42.42h-4.73c-.25 0-.42-.17-.42-.42v-9.29c-.01-.17.16-.42.42-.42zm-18.25-5.66h4.73c.25 0 .42.17.42.43v15.04c0 .25-.17.42-.42.42h-4.73c-.25 0-.42-.17-.42-.42V24.33c-.09-.25.17-.42.42-.42zm9.12-3.21h4.73c.25 0 .42.17.42.42v18.25c0 .25-.17.42-.42.42h-4.73c-.25 0-.42-.17-.42-.42V21.12c0-.25.17-.42.42-.42zM33.2 40.72l14.36.25c0 5.15-2.53 9.88-6.76 12.76l-7.6-13.01zm-1.44-2.45-.17-16.73v-1.1l1.1.08c1.35.08 2.7.34 3.97.68s2.45.84 3.63 1.44c5.83 3.04 9.88 9.12 10.22 16.05l.08 1.1h-1.1l-16.64-.51h-.93l-.16-1.01zm1.86-15.71.17 14.7 14.62.42c-.59-5.75-4.14-10.73-9.04-13.35-1.01-.51-2.11-.93-3.21-1.27-.93-.16-1.69-.33-2.54-.5zm-3.29 17.32 8.19 14.19c-2.53 1.44-5.32 2.2-8.19 2.2-9.04 0-16.39-7.35-16.39-16.39 0-8.79 6.93-16.05 15.71-16.39l.68 16.39z"
      fill={'whitesmoke'}
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
      }}
    />
  </svg>
)
export default OptimizeSVG
